import { useNavigate } from 'react-router';
import { useTrainerClients } from '../../api/queries';
import { QueryBoundary } from '../../components/QueryBoundary';
import { PageHeader } from '../../components/PageHeader';
import { useTranslation } from '../../i18n/I18nProvider';
import { WeeklyAttention } from './WeeklyAttention';
import { SkeletonList, StatTile } from '../../ui';

/**
 * Trenerova početna.
 *
 * Popis klijenata stoji SAMO u „Traži pažnju" (sekcija 37) — poredan po tome
 * tko traži reakciju danas, s razlogom uz ime. Ispod njega je do 12.09.2026.
 * stajao još jedan popis istih ljudi, s drugim značkama za iste podatke
 * („4 propuštenih treninga" gore, „4 propuštenih" dolje). Dva popisa istih
 * klijenata na jednom ekranu ne daju više informacije nego jedan; daju pitanje
 * koji od njih gledati.
 *
 * Brojke tjedna idu iznad popisa: to je jedina stvar koja se čita odjednom, a
 * bila je zaglavljena između dva popisa.
 */
export function TrainerDashboard() {
  const { t } = useTranslation();
  const query = useTrainerClients();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader eyebrow={t('shell.trainer')} title={t('portal.dashboard')} />

      <div className="flex flex-col gap-6">
        <QueryBoundary
          query={query}
          skeleton={<SkeletonList rows={1} />}
          isEmpty={(d) => d.items.length === 0}
          empty={{
            message: t('empty.noClients'),
            actionLabel: t('shell.clients'),
            onAction: () => void navigate('/trener/klijenti'),
          }}
        >
          {(data) => {
            const totalDone = data.items.reduce((n, c) => n + c.consistency.done, 0);
            const totalPlanned = data.items.reduce((n, c) => n + c.consistency.planned, 0);
            const missedTotal = data.items.reduce((n, c) => n + c.missedWorkouts, 0);

            return (
              <div className="grid gap-3 sm:grid-cols-3">
                <StatTile label={t('shell.clients')} value={data.items.length} />
                <StatTile
                  label={t('trainer.consistency')}
                  value={totalPlanned ? Math.round((totalDone / totalPlanned) * 100) : 0}
                  unit="%"
                />
                <StatTile label={t('trainer.flagMissed', { n: '' }).trim()} value={missedTotal} />
              </div>
            );
          }}
        </QueryBoundary>

        <WeeklyAttention />
      </div>
    </>
  );
}
